import React from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { InfoFormProps } from "../../../../../../types/Forms";
import { AgreeTerms, Github, GiveFeedback, LinkedIn, SelectState } from "../../../../../../constants";

const FeedbackForm: React.FC<InfoFormProps> = ({ register, errors, updateFormData, formData }) => {
  return (
    <Form className="needs-validation custom-input" noValidate>
      <Row className="g-3">
        <Col sm="6">
          <Label>{LinkedIn}<span className="txt-danger">*</span></Label>
          <Input value={formData.linkedInLink} {...register("linkedInLink", { required: "LinkedIn link  is required" })} onChange={updateFormData} type="url" placeholder="https://linkedIn.com/zono" />
          {errors.linkedInLink && <span className="text-danger">{errors.linkedInLink.message}</span>}
        </Col>
        <Col sm="6">
          <Label>{Github}<span className="txt-danger">*</span></Label>
          <Input value={formData.gitHubLink} {...register("gitHubLink", { required: "Github link is required" })} onChange={updateFormData} type="url" placeholder="https://github.com/zono" />
          {errors.gitHubLink && <span className="text-danger">{errors.gitHubLink.message}</span>}
        </Col>
        <Col xs="12"> 
          <Label>{SelectState}<span className="txt-danger">*</span></Label>
          <Input type="select" {...register("state", { required: "State is required" })} onChange={updateFormData}>
            <option value="">{"Choose..."}</option>
            <option value="U.K">{"U.K "}</option>
            <option value="U.S">{"U.S "}</option>
            <option value="India">{"India"}</option>
          </Input>
          {errors.state && <span className="text-danger">{errors.state.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{GiveFeedback}</Label>
          <Input type="textarea" value={formData.giveFeedBack} {...register("giveFeedBack", { required: "Feedback is required" })} onChange={updateFormData} />
          {errors.giveFeedBack && <span className="text-danger">{errors.giveFeedBack.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check>
            <Input id="invalidCheck46" {...register("agreeConditions", { required: true })} onChange={updateFormData} type="checkbox" required />
            <Label className="mb-0" htmlFor="invalidCheck46" check>{AgreeTerms}</Label>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default FeedbackForm;
